import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';
import type {
    DepotChannelsApiResponse,
    DepotChannelsRequestPayload
} from './types/companies-channels.types';

const API_VERSION = 'v2';

const response = {
    async postGetChannels(
        payload: DepotChannelsRequestPayload
    ): Promise<DepotChannelsApiResponse | null> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/channels`,
            payload,
            undefined,
            'application/json',
            API_VERSION
        );
    },
    async postExportChannels(
        payload: DepotChannelsRequestPayload
    ): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/channels`,
            payload,
            undefined,
            'application/json',
            API_VERSION,
            {
                Accept: 'text/csv'
            }
        );
    }
};

export default response;